/* Important Info component for the Locations Create page */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../styles/PostCreateEditForm.module.css";

const InfoCreate = () => {
  return (
    <div>
        <Row className="my-3">
        <Col md={{span: 8, offset: 2}}>
        <div className={`text-center px-3 py-2 ${styles.SubTitle6 }`}>
            <p className={`${styles.Red} text-center`}>INFO</p>
            <hr className={`mt-2 mb-0`}/>
        <p className={`text-center`}>
          <span className={`${styles.Red}`}>*</span> All Characters must be assigned a <span className={`${styles.Red}`}>Number</span>. This cannot be changed.     
          </p>    
          <p className={`text-center pt-2`}>
          <span className={`${styles.Red}`}>*</span> The Dropdowns below
          contain all the currently <span className={`${styles.Red}`}>unused</span> Numbers.         
          </p>
          <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoCreate